module.exports = __webpack_public_path__ + "static/media/Cooperationbg2@3x.37800e52.png";